const trashs = [
  { label: 'default', value: 'default.jpg' },
  { label: 'chemistry', value: 'chemistry.jpg' }
]

export default trashs



// WEBPACK FOOTER //
// ./src/modules/Presentation/Constants/trash.js